import React, { useEffect, useState } from 'react'
import { Interweave } from 'interweave'
import axios from 'axios'
import "../css/landing.css";
import "../css/swalComponent.css";


function AboutUs() {
  const [data, setData] = useState()
  const getdata = () => {
    // e.preventDefault();
    // const access_token = localStorage.getItem('token')
    // const headers = {
    //   Authorization: `Bearer ${access_token}`
    // }
    axios
      .get(`https://13.126.68.184/api/api/term/condition/About-Us`)
      .then((res) => {
        setData(res.data[0].Desc)
      })
  }

  useEffect(() => {
    getdata()
  }, [])

  return (
    <div className="px-3 py-4 mt-5 leftContainer">
      <Interweave content={data && data} />
      <div className="px-3 py-4">
              <div className="footer-text-bold">About Us</div>

              <div className="footer-text">
                GamesDuniais a real-money gaming product owned and  <br></br>operated by
                GamesDuniaEntertainment Company("GamesDuniaEntertainment Company" or "We" or "Us" or "Our").
              </div>

              <div className="footer-text-bold mt-3">
                Our Business &amp; Products
              </div>

              <div className="footer-text mt-2" >
                We are an HTML5 game-publishing company and our mission is to
                make accessing games fast and easy by removing the friction of
                app-installs.
              </div>

              <div className="footer-text mt-2">
                GamesDuniais a skill-based real-money gaming platform accessible
                only for our users in India. It is accessible on{" "}
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.gamesduniaentertainment.com"
                >
                  https://www.gamesduniaentertainment.com
                </a>
                . On GamesDunia, users can compete for real cash in Tournaments
                and Battles. They can encash their winnings via popular options
                such as Paytm Wallet, Amazon Pay, Bank Transfer, Mobile
                Recharges etc.
              </div>

              <div className="footer-text-bold mt-2">Our Games</div>

              <div className="footer-text">
                GamesDuniahas a wide-variety of high-quality, premium HTML5
                games. Our games are especially compressed and optimised to work
                on low-end devices, uncommon browsers, and patchy internet
                speeds.
              </div>

              <div className="footer-text mt-2">
                We have games across several popular categories: Arcade, Action,
                Adventure, Sports &amp; Racing, Strategy, Puzzle &amp; Logic. We
                also have a strong portfolio of multiplayer games such as Ludo,
                Chess, 8 Ball Pool, Carrom, Tic Tac Toe, Archery, Quiz, Chinese
                Checkers and more! Some of our popular titles are: Escape Run,
                Bubble Wipeout, Tower Twist, Cricket Gunda, Ludo With Friends.
                If you have any suggestions around new games that we should add
                or if you are a game developer yourself and want to work with
                us, don't hesitate to drop in a line at{" "}
                <a href="mailto:info@gamesduniaentertainment.com">info@gamesduniaentertainment.com</a>!
              </div>
            </div>
    </div>
  )
}

export default AboutUs
